import axiosInstance from "@/api/AxiosInstance";

export const requestResetOTP = (email: string) =>
  axiosInstance.post("/password/reset/otp/", { email });

export const resendResetOTP = (email: string) =>
  axiosInstance.post("/password/reset/otp/resent/", { email });

export const verifyResetOTP = (email: string, otp: string) =>
  axiosInstance.post("/password/reset/otp/verify/", { email, otp });

export const changePassword = (email: string, new_password: string) =>
  axiosInstance.patch("/password/change/", { email, new_password });
